// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tag-modal .checking-input[data-v-524dea54]{position:absolute;top:8px;right:8px;left:unset}", ""]);
// Exports
module.exports = exports;
